import React, { forwardRef } from 'react';

// AskBlock — renders a structured ask sub-doc:
//   { text, type, urgency, section, options:[{label,tone}], ... }
// onRespond focuses the composer (the "note instead" affordance + fallback).
// onAnswer, if provided, answers directly with a fork payload from an option.
const AskBlock = forwardRef(function AskBlock({ ask, onRespond, onAnswer }, ref) {
  const a = ask || {};
  const options = Array.isArray(a.options) ? a.options : [];

  function pick(opt) {
    if (onAnswer) onAnswer({ kind: 'fork', choice: opt.label });
    else if (onRespond) onRespond();
  }

  return (
    <div className="ask-block" ref={ref}>
      <div className="ask-label">THE ASK</div>
      <p className="ask-text">"{a.text}"</p>
      <div className="ask-actions">
        {options.length > 0
          ? options.map((opt, k) => (
              <button key={k}
                      type="button"
                      className={`btn small ${opt.tone === 'primary' ? 'accent' : 'ghost'}`}
                      onClick={() => pick(opt)}>
                {opt.label}
              </button>
            ))
          : <button type="button" className="btn small accent" onClick={onRespond}>Respond</button>
        }
        <button type="button" className="btn small ghost" onClick={onRespond}>Write a note instead</button>
      </div>
    </div>
  );
});

export default AskBlock;
